module.exports = __webpack_public_path__ + "img/tree-fill.ee66b0f4.svg";